import { createFeature, createReducer, createSelector, on } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Administration } from "./administration.model";
import { AdministrationActions } from "./administration.actions";

export const administrationsFeatureKey = "administrations";

export interface State extends EntityState<Administration> {
  // additional entities state properties
  loading: boolean;
  users: any;
  cpt: any;
  legal_entities: any;
  esg: any;
  risks: any;
}

export const adapter: EntityAdapter<Administration> =
  createEntityAdapter<Administration>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loading: false,
  users: {},
  cpt: {},
  legal_entities: {},
  esg: {},
  risks: {}
});

export const reducer = createReducer(
  initialState,
  on(AdministrationActions.addAdministration, (state, action) =>
    adapter.addOne(action.administration, state)
  ),
  on(AdministrationActions.upsertAdministration, (state, action) =>
    adapter.upsertOne(action.administration, state)
  ),
  on(AdministrationActions.addAdministrations, (state, action) =>
    adapter.addMany(action.administrations, state)
  ),
  on(AdministrationActions.upsertAdministrations, (state, action) =>
    adapter.upsertMany(action.administrations, state)
  ),
  on(AdministrationActions.updateAdministration, (state, action) =>
    adapter.updateOne(action.administration, state)
  ),
  on(AdministrationActions.updateAdministrations, (state, action) =>
    adapter.updateMany(action.administrations, state)
  ),
  on(AdministrationActions.deleteAdministration, (state, action) =>
    adapter.removeOne(action.id, state)
  ),
  on(AdministrationActions.deleteAdministrations, (state, action) =>
    adapter.removeMany(action.ids, state)
  ),
  on(AdministrationActions.loadAdministrations, (state, action) =>
    adapter.setAll(action.administrations, state)
  ),
  on(AdministrationActions.clearAdministrations, (state) =>
    adapter.removeAll(state)
  ),

  //action user
  on(AdministrationActions.getUsers, (state, action) => {
    return {
      ...state,
      loading: true
    };
  }),

  on(AdministrationActions.getUsersSuccess, (state, action) => {
    return {
      ...state,
      users: action.user,
      loading: false
    };
  })
);

export const administrationsFeature = createFeature({
  name: administrationsFeatureKey,
  reducer,
  extraSelectors: ({ selectAdministrationsState, selectUsers }) => ({
    ...adapter.getSelectors(selectAdministrationsState),
    selectUser: createSelector(selectUsers, (elem) => {
      return elem.results;
    }),
    selectUserCount: createSelector(selectUsers, (elem) => {
      return elem.count;
    })
  })
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
  selectUsers,
  selectUser,
  selectUserCount
} = administrationsFeature;
